import { useReactiveVar, gql, useMutation } from '@apollo/client';
/* eslint-disable camelcase */
import { promocodeVar, selectedPeriodVar } from 'app/apollo/reaction';

/* NETWORK */
import { onCompletedBillingMutation } from 'app/containers/BasketResolver';
import { useBillingMutationVars } from './accessors/useBillingMutationVars';

const MUTATE_BILLING = gql`
    mutation MUTATE_BILLING_HOOK(
        $promocode: String,
        $period: String!,
        $payment_method: paymentMethod,
        $phone: String,
    ) {
        billing(
            promocode: $promocode,
            period: $period,
            payment_method: $payment_method,
            phone: $phone,
        ) {
            promocode
            payment_method
            cart {
                period
                isSubscriptionActivated
                id
                type
                totals {
                    ...ROOT_CART_TOTAL
                }
                discount_conditions {
                    ...ROOT_CART_DISCOUNT_CONDITIONS
                }
            }
        }
    }
`;

const BASKET_BILLING_QUERY = gql`
    query REFETCH_BASKET_BILLING_QUERY(
    $period: String!
) {
    selectedPeriod @client @export(as: "period")

    cart(
        period: $period
    ) {
        period
        isSubscriptionActivated
        id
        type
        totals {
            ...ROOT_CART_TOTAL
        }
        discount_conditions {
            ...ROOT_CART_DISCOUNT_CONDITIONS
        }
        sections {
            id
            title
            gift_category
            items {
                ...ROOT_CART_DISH_ITEM
                dish {
                    ...ROOT_MENU_DISH_ITEM
                }
            }
            cartType
        }
    }
}`;

export const MENU_DISHES_BILLING_QUERY = gql`
    query REFETCH_MENU_DISHES_BILLING_QUERY(
    $period: String!
) {
    selectedPeriod @client @export(as: "period")

    menuDishes(
        period: $period,
    ) {
        priority
        parentId
        availableStatus
        visibleStatus
        id,
        title,
        titleEn,
        caption,
        captionEn,
        composition,
        weight,
        price,
        promoPrice,
        portions,
        previewImage,
        previewMobileImage,
        umAlias,
        category_id,
        category_description
        subcategory_id
        subcategory_name
        cooking_time
        secondDishPart,
        parentId
        replaceableIngredient,
        tags {
            id
        },
        visibleStatus,
        nutrition {
            carbohydrate {
            title
            value
            unit
            }
            fat {
            title
            value
            unit
            }
            protein {
            title
            value
            unit
            }
            calories {
            title
            value
            unit
            }
        }
        partnerAdSignature
        partnerErid
        partnerPhotoBackground
        additionalDescription
        option_tags
        highlight_words
        highlight_description
        highlight_description_title
        highlight_image
        previewMobileAlterImage
    }
}`;

/**
 * @description Ставит query парамерт payment и promo_code
 */
export const useBillingMutation = () => {
    const period = useReactiveVar(selectedPeriodVar);
    const promocode = useReactiveVar(promocodeVar);
    const billingVars = useBillingMutationVars();

    const [mutate, { loading: billingLoading }] = useMutation(MUTATE_BILLING, {
        onError: (err) => {
            console.log(err);
            // Raven.captureException(e);
        },
        onCompleted: (data) => { onCompletedBillingMutation(data); },
        // onCompleted: ({ billing }, option) => {
        //     // console.log(billing, option);
        //     // const { payment_method, promocode } = billing;
        //     // // @ts-expect-error тут есть!
        //     // const { variables: { phone } } = option;
        //     // setBillingStateVar({ payment_method, promocode, phone });
        //     // const type = ['recurrent'].includes(payment_method) ? 'subscription' : 'singlePay';
        //     // subscriptionTypeVar(type)
        //     // setInitialPromoAndPaymentAsQueryParam([{ payment: payment_method }, { promo_code: promocode }]);
        // },
        variables: {
            period,
        },
        context: {
            message: 'global:mutate:useBillingMutation',
        },
        refetchQueries: [
            {
                query: BASKET_BILLING_QUERY,
                context: { message: 'global:refetch:useBillingMutation' },
                variables: { period },
            },
            {
                query: MENU_DISHES_BILLING_QUERY,
                context: { message: 'global:refetch:useBillingMutation' },
                variables: { period },
            },
        ],
    });

    // const notEqual = (prev: any, next: any) => JSON.stringify(prev) !== JSON.stringify(next);

    // eslint-disable-next-line no-unused-vars
    const mutateBilling = async ({ variables }: any, caller?: string) => {
        // // console.log(caller);
        const combained = {
            ...billingVars,
            period,
            promocode,
            ...variables,
        };
        // if (notEqual(combained, state)) {
        // }
        const { data } = await mutate({ variables: { ...combained } });
        return data;
    };

    return { mutateBilling, billingLoading };
};
